import script from "./PlatformInfoTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformInfoTab.vue?vue&type=script&setup=true&lang=js"

import "./PlatformInfoTab.vue?vue&type=style&index=0&id=201cf910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201cf910"]])

export default __exports__